import React from 'react'
import Header from './components/molecules/Header'
import Cover from './components/molecules/Presentation'
import Services from './components/molecules/Services'
import Infos from './components/molecules/Infos'
import About from './components/molecules/About'
import Review from './components/molecules/Review'
import WhoAmI from './components/molecules/WhoAmI'
import Footer from './components/molecules/Footer'
// import Spacer from './components/atoms/Spacer'
import ReactGA from 'react-ga4';


const TRACKING_ID = "G-CLLH9PFMB0";
ReactGA.initialize(TRACKING_ID);

function App() {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <body
      style={{
        backgroundColor: '#F3FFF5',
      }}
    >
      <Header />
      <Cover />
      <WhoAmI />
      <Services />
      <Infos />
      <About />
      <Review />
      <Footer />
    </body>
  )
}

export default App
